import { Component } from '@angular/core';
import { TextWindowComponent} from "../subcomponents/text-window/text-window.component";

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [TextWindowComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {

}
